//import Libraries
import React, {Component} from 'react';
import {connect} from 'react-redux'

//import Components
import {Container} from 'reactstrap';

import AccountPagination from './AccountPagination';

//import Styles
import '../Admin.css'

class AccountManager extends Component{

    constructor(props) {
        super(props);
        this.state = {

        } 
    }

    render() {
        return (
            <div className="admin-element" >
                <Container>
                    <h1>
                        회원 관리
                    </h1>
                    <hr />
                </Container>
                <Container>
                    <AccountPagination 
                        accounts={this.props.accounts}
                    />
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        accounts : state.accounts
    }
}

export default connect(mapStateToProps, null)(AccountManager);


// WEBPACK FOOTER //
// ./src/pages/Admin/AccountManager/AccountManager.js